var map = {
	"./base/locale/ar/forms.json": 87853,
	"./base/locale/ar/keys.json": 27062,
	"./base/locale/ar/legal.json": 23973,
	"./base/locale/ar/translations.json": 5838,
	"./base/locale/de/forms.json": 94285,
	"./base/locale/de/keys.json": 13657,
	"./base/locale/de/legal.json": 57273,
	"./base/locale/de/translations.json": 73113,
	"./base/locale/en/forms.json": 70235,
	"./base/locale/en/keys.json": 53502,
	"./base/locale/en/legal.json": 36350,
	"./base/locale/en/translations.json": 52760,
	"./base/locale/es/forms.json": 76064,
	"./base/locale/es/keys.json": 79128,
	"./base/locale/es/legal.json": 53956,
	"./base/locale/es/translations.json": 71941,
	"./base/locale/fr/forms.json": 27110,
	"./base/locale/fr/keys.json": 42061,
	"./base/locale/fr/legal.json": 74073,
	"./base/locale/fr/translations.json": 70000,
	"./base/locale/it/forms.json": 33839,
	"./base/locale/it/keys.json": 81683,
	"./base/locale/it/legal.json": 30205,
	"./base/locale/it/translations.json": 69883,
	"./base/locale/lt/forms.json": 10462,
	"./base/locale/lt/keys.json": 13448,
	"./base/locale/lt/legal.json": 92630,
	"./base/locale/lt/translations.json": 97991,
	"./base/locale/ru/forms.json": 7419,
	"./base/locale/ru/keys.json": 59241,
	"./base/locale/ru/legal.json": 39130,
	"./base/locale/ru/translations.json": 52565,
	"./base/locale/tr/forms.json": 421,
	"./base/locale/tr/keys.json": 48111,
	"./base/locale/tr/legal.json": 75133,
	"./base/locale/tr/translations.json": 59141,
	"./base/locale/ur/forms.json": 6779,
	"./base/locale/ur/legal.json": 41571,
	"./base/locale/ur/translations.json": 21839,
	"./base/locale/zh/forms.json": 25015,
	"./base/locale/zh/keys.json": 31630,
	"./base/locale/zh/legal.json": 97447,
	"./base/locale/zh/translations.json": 50736,
	"./swisstech/locale/en/override.json": 57094
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20248;